// extracted by mini-css-extract-plugin
export default {"studioTimes":"pe0Mi"};